module.exports = __webpack_public_path__ + "static/img/Bike Tours.64eacfb.png";